import React from "react";
import LegalPageLayout from "./LegalPageLayout";

export default function BuddyAvanzaPrivacy() {
  return (
    <LegalPageLayout
      documentKey="privacy"
      testid="legal-privacy"
      eyebrow="Documento legal"
      documentTitle="Política de Privacidad de BUDDY AVANZA"
      intro="Esta política describe cómo BUDDY AVANZA trata la información asociada al uso del servicio, con foco en transparencia, protección de menores y buenas prácticas educativas."
    >
      {({ contactEmail, operator }) => (<>
        <section>
          <h2>1. Responsable</h2>
          <p><strong>{operator}</strong> es responsable del tratamiento de la
             información asociada al uso de BUDDY AVANZA.</p>
        </section>

        <section>
          <h2>2. Información tratada</h2>
          <p>De acuerdo con el diseño actual del servicio, BUDDY AVANZA puede
             tratar la siguiente información según sea necesario para el
             funcionamiento del producto:</p>
          <ul>
            <li>Correo electrónico del estudiante.</li>
            <li>Fecha de nacimiento del estudiante.</li>
            <li>Condición mayor / menor de edad.</li>
            <li>Correo electrónico del padre, madre, tutor legal o adulto responsable, cuando el estudiante es menor.</li>
            <li>Nombre y grado del estudiante.</li>
            <li>Aceptación de los documentos legales, la versión aceptada y la fecha de aceptación.</li>
            <li>Progreso educativo dentro de la plataforma: materias, habilidades, intentos, resultados e indicadores agregados.</li>
            <li>Información técnica mínima necesaria para seguridad, integridad y disponibilidad del servicio.</li>
          </ul>
          <p>BUDDY AVANZA no solicita ni almacena documentos de identidad,
             fotos personales, DUI, pasaporte o credenciales financieras
             completas.</p>
        </section>

        <section>
          <h2>3. Finalidades</h2>
          <ul>
            <li>Crear y administrar la cuenta del estudiante y, cuando corresponda, del adulto responsable.</li>
            <li>Determinar el flujo de consentimiento aplicable.</li>
            <li>Proporcionar y personalizar la experiencia educativa.</li>
            <li>Medir progreso y proporcionar retroalimentación.</li>
            <li>Seguridad, prevención de abuso y soporte.</li>
            <li>Cumplimiento de obligaciones aplicables.</li>
            <li>Mejora continua del funcionamiento del servicio.</li>
          </ul>
        </section>

        <section>
          <h2>4. Menores de 18 años</h2>
          <p>BUDDY AVANZA aplica un flujo diferenciado para estudiantes
             menores de 18 años que requiere consentimiento parental. En este
             flujo se mantienen correos electrónicos independientes para el
             estudiante y para el adulto responsable. El padre o responsable
             puede visualizar el progreso del estudiante y las credenciales
             no se comparten.</p>
        </section>

        <section>
          <h2>5. Buddy e inteligencia artificial</h2>
          <p>Buddy es un componente educativo que puede utilizar sistemas
             automatizados y tecnologías de inteligencia artificial para
             acompañar el razonamiento del estudiante. Respecto al
             tratamiento de información:</p>
          <ul>
            <li>Se persisten únicamente señales agregadas del comportamiento educativo (por ejemplo, si el estudiante interactuó, avanzó o solicitó ayuda).</li>
            <li><strong>No</strong> se persiste el contenido literal de las conversaciones con Buddy ni las respuestas completas del modelo generativo.</li>
            <li>La información enviada al componente generativo se limita al contexto pedagógico mínimo necesario para producir el acompañamiento educativo.</li>
            <li>Durante determinadas evaluaciones y simulaciones, la asistencia de Buddy se restringe para preservar la finalidad diagnóstica de la actividad.</li>
          </ul>
        </section>

        <section>
          <h2>6. Pagos</h2>
          <p>Los pagos son procesados a través de un <strong>proveedor externo de
             procesamiento de pagos</strong>. BUDDY AVANZA no almacena números
             completos de tarjeta, CVV ni otros datos financieros sensibles.
             El proveedor externo aplica sus propias medidas de seguridad
             conforme a los estándares del sector.</p>
        </section>

        <section>
          <h2>7. Conservación</h2>
          <p>La información se conservará durante el período necesario para
             prestar el servicio, atender obligaciones legales, contables y
             probatorias aplicables, preservar la seguridad, resolver
             incidencias y otros fines legítimos relacionados con el
             funcionamiento del producto. Los criterios de retención por
             categoría de datos están definidos internamente por {operator} y
             pueden variar según la finalidad. Los plazos específicos aplicables
             a evidencia contable, contractual y probatoria se rigen por la
             legislación correspondiente. {operator} no promete eliminación
             automática de la información: las solicitudes de cancelación o
             eliminación se atienden por el canal indicado en la sección 9.</p>
        </section>

        <section>
          <h2>8. Seguridad</h2>
          <p>BUDDY AVANZA aplica medidas técnicas y organizativas razonables
             para proteger la información. Ningún sistema conectado a
             Internet garantiza seguridad absoluta.</p>
        </section>

        <section>
          <h2>9. Derechos de las personas titulares</h2>
          <p>Conforme a la legislación aplicable en materia de protección de
             datos personales en El Salvador (incluido el Decreto Legislativo
             144), las personas titulares —o su padre, madre, tutor legal o
             adulto responsable, cuando el titular sea menor de edad— podrán
             solicitar el ejercicio de los siguientes derechos respecto de
             la información asociada al uso de BUDDY AVANZA:</p>
          <ul>
            <li><strong>Acceso</strong>: solicitar información sobre los datos personales tratados.</li>
            <li><strong>Rectificación</strong>: solicitar la corrección de datos inexactos o desactualizados.</li>
            <li><strong>Cancelación</strong>: solicitar la eliminación de datos cuando resulte procedente.</li>
            <li><strong>Oposición</strong>: solicitar el cese del tratamiento en supuestos aplicables.</li>
            <li><strong>Portabilidad</strong>: solicitar una copia de datos en un formato de uso común, cuando aplique.</li>
            <li><strong>Retiro de consentimiento</strong>: retirar el consentimiento otorgado previamente, sin efecto retroactivo sobre tratamientos ya realizados.</li>
          </ul>
          <p>Las solicitudes deben enviarse al canal indicado en la
             sección 10, incluyendo el tipo de solicitud y evidencia
             razonable que permita verificar la identidad del solicitante o,
             cuando aplique, la relación con el estudiante menor de edad.
             {operator} atenderá las solicitudes en plazos razonables,
             pudiendo requerir verificación adicional. Algunas categorías de
             información pueden estar sujetas a obligaciones legales de
             conservación (por ejemplo, evidencia contable, contractual o
             probatoria) y podrían no ser eliminables mientras dichas
             obligaciones subsistan; en tales casos se informará al
             solicitante.</p>
        </section>

        <section>
          <h2>10. Contacto de privacidad</h2>
          <p>
            Para consultas relacionadas con privacidad, protección de datos
            personales o ejercicio de los derechos indicados en la sección 9,
            puedes comunicarte con {operator} a través de{" "}
            <a href={`mailto:${contactEmail}`} data-testid="privacy-contact-email">{contactEmail}</a>.
            Se recomienda indicar en el asunto <em>[PRIVACIDAD] BUDDY AVANZA</em>{" "}
            para facilitar la atención de la solicitud.
          </p>
        </section>

        <section>
          <h2>11. Terceros que participan en el tratamiento</h2>
          <p>Para operar BUDDY AVANZA, {operator} utiliza proveedores
             externos que actúan como encargados del tratamiento, cada uno
             de acuerdo con la función que presta dentro del servicio y con
             las condiciones aplicables a su participación en el tratamiento
             de información. Las categorías principales son:</p>
          <ul>
            <li><strong>Proveedor de inteligencia artificial</strong> (por ejemplo, OpenAI): procesa contexto pedagógico pseudonimizado para el acompañamiento de Buddy. Ver también el Aviso de Inteligencia Artificial.</li>
            <li><strong>Infraestructura y plataforma de aplicación</strong> (Emergent): aloja el backend y ejecuta la lógica del servicio.</li>
            <li><strong>Base de datos gestionada</strong> (MongoDB Atlas): almacena la información necesaria para operar el servicio.</li>
            <li><strong>Proveedor de correo transaccional</strong> (Brevo): envía correos operativos como bienvenida, enlaces de acceso o notificaciones asociadas al uso del servicio.</li>
            <li><strong>Proveedor de red de distribución de contenido y seguridad de tráfico</strong> (Cloudflare): interviene en la transmisión segura del tráfico web.</li>
            <li><strong>Proveedor de procesamiento de pagos</strong> (N1CO): procesa los pagos del servicio conforme a su propia política.</li>
            <li><strong>Proveedor de analítica de producto</strong>: en las rutas del servicio BUDDY AVANZA, {operator} ha desactivado la analítica de producto sobre estudiantes y responsables (ver sección 13).</li>
          </ul>
          <p>{operator} mantiene un registro interno de estos proveedores.
             La lista anterior puede actualizarse cuando cambien los
             proveedores utilizados.</p>
        </section>

        <section>
          <h2>12. Procesamiento fuera de El Salvador</h2>
          <p>Algunos proveedores tecnológicos pueden realizar procesamiento
             de información fuera de El Salvador. {operator} adopta medidas
             razonables y aplicables para que dicho tratamiento se limite a
             las finalidades descritas en esta Política y se gestione de
             acuerdo con las obligaciones aplicables en materia de
             protección de datos personales. {operator} selecciona
             proveedores tecnológicos considerando criterios de seguridad,
             confidencialidad y adecuación al servicio, y mantiene bajo
             revisión las condiciones aplicables al tratamiento de
             información por dichos proveedores.</p>
        </section>

        <section>
          <h2>13. Analítica de producto</h2>
          <p>{operator} podría utilizar servicios de analítica de producto
             para entender el uso del sitio web corporativo. En las rutas
             que corresponden al servicio BUDDY AVANZA (<code>/avanzo/*</code>{" "}
             y <code>/buddy-avanza/*</code>) esta analítica se encuentra
             desactivada para estudiantes y responsables. Cualquier cambio
             en esta configuración será reflejado en esta política.</p>
        </section>
      </>)}
    </LegalPageLayout>
  );
}
